import React, { useContext, useState } from 'react'
import LoadingGif from '../../../../assets/loading'
import ImportFromExcelContext from '../../../../contexts/ImportFromExcelContext'
import StockContext from '../../../../contexts/StockContext'
import {
  Container,
  HeaderDiv,
  HeaderText,
  CloseDiv,
  CloseImg,
  ProgressBarDiv,
  ProgressBarCircle,
  ProgressBarLine,
  Phrase,
  LoadingMessage,
  ProgressContainer,
  ProgressFill,
  FileInputDiv,
  FileInputLabel,
  FileInput,
  FileInfoDiv,
  FileInfoImg,
  FileMiddleDiv,
  FileUpperMiddleDiv,
  FileName,
  FilePercentage,
  FileInfoCancelImg,
  FileFirstText,
  FileSecondText,
  ButtonsDiv,
  CancelButton,
  NextButtonDiv,
  NextButtonImage,
  NextButtonText,
  DisabledNextButtonDiv,
  DisabledNextButtonImage,
  DisabledNextButtonText,
} from './style'
import cross from '../../../../assets/addStockModal/cross.svg'
import fileIcon from '../../../../assets/addStockModal/excel/file.svg'
import cancelIcon from '../../../../assets/addStockModal/excel/cancel.svg'
import arrowRight from '../../../../assets/addStockModal/excel/arrow-right.svg'
import disabledArrowRight from '../../../../assets/addStockModal/excel/disabled-arrow-right.svg'
import UserContext from '../../../../contexts/UserContext'
import axios from '../../../../config/axios'
import ModalContext from '../../../../contexts/ModalContext'

const UploadStep = () => {
  const { tableFile, setTableFile } = useContext(StockContext)
  const { setModalActive, setModalSection } = useContext(ModalContext)
  const { token, user } = useContext(UserContext)
  const {
    activeTab,
    setActiveTab,
    setPreviewSpreadsheet,
    setTranslationMapping,
    loadingPercentage,
    setLoadingPercentage,
  } = useContext(ImportFromExcelContext)
  const [loadingMessage, setLoadingMessage] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)

  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files: any = e.target.files!
    setTableFile(files)
    setLoadingPercentage([])
  }

  const ProgressHandler = (e: ProgressEvent<XMLHttpRequestEventTarget>) => {
    const percent = (e.loaded / e.total) * 100
    const newPercentage = [percent.toFixed(0)]
    setLoadingPercentage(newPercentage)
  }

  const ProgressBar = (props: any) => {
    const fillerStyles = {
      width: `${props.completion}%`,
    }

    return (
      <ProgressContainer>
        <ProgressFill style={fillerStyles} />
      </ProgressContainer>
    )
  }

  const handleDelete = () => {
    const erasedFile = undefined
    const erasedPercentage = []
    setTableFile(erasedFile)
  }

  const handleSubmit = () => {
    const formData = new FormData()
    formData.append('file', tableFile[0])

    const file = tableFile[0]
    setLoading(true)
    setLoadingMessage('Carregando')
    axios
      .post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/excel-preview`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent: any) => {
          if (progressEvent && progressEvent.total) {
            const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            setLoadingPercentage([percent])
          }
        },
      })
      .then((res) => {
        setLoadingMessage('Concluído !')
        setPreviewSpreadsheet(res.data)
        setTranslationMapping({})
        setTimeout(() => {
          setModalSection('secondExcelAdd')
        }, 1000)
      })
      .catch((err) => {
        setLoadingMessage('Erro ao tentar carregar !')
      })
  }

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      setTableFile([files[0]]);
      setLoadingPercentage([])
    }
  };

  return (
    <Container>
      <HeaderDiv>
        <HeaderText>Adicionar estoque</HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
          <CloseImg src={cross} alt='Close tab' />
        </CloseDiv>
      </HeaderDiv>
      <ProgressBarDiv>
        <ProgressBarCircle className='active' />
        <ProgressBarLine />
        <ProgressBarCircle />
        <ProgressBarLine />
        <ProgressBarCircle />
      </ProgressBarDiv>
      <Phrase>
        <div>
          Faça upload da planilha em formato .xslx (Excel). Cada linha deve ser
          um produto com código (SKU) diferente, enquanto cada coluna deve ser
          um tipo de informação (Material, Formato, Acabamento, etc).
        </div>
        <div>
          <a href='../../../Estoque.xlsx' download>
            Baixar planilha padrão
          </a>
        </div>
        <div>
          <a href='../../../Regras_de_importacao.docx' download>
            Regras de importação
          </a>
        </div>
      </Phrase>
      {tableFile === undefined ? (
        <FileInputDiv
          onDragOver={handleDragOver}
          onDrop={handleDrop}
        >
          <FileInputLabel htmlFor='invoice'>
            Procurar
            <FileInput
              type='file'
              id='invoice'
              name='invoice'
              onChange={handleUpload}
            />
          </FileInputLabel>
          <FileFirstText>ou arraste um arquivo até aqui</FileFirstText>
          <FileSecondText>
            Apenas arquivos .pdf de no máximo 10mb
          </FileSecondText>
        </FileInputDiv>
      ) : (
        <>
          <FileInfoDiv>
            <FileInfoImg src={fileIcon} alt='File icon' />
            <FileMiddleDiv>
              <FileUpperMiddleDiv>
                <FileName>{tableFile[0].name}</FileName>
                <FilePercentage>{loadingPercentage[0]}%</FilePercentage>
              </FileUpperMiddleDiv>
              <ProgressBar completion={loadingPercentage[0]} />
            </FileMiddleDiv>
            <FileInfoCancelImg
              src={cancelIcon}
              alt='File icon'
              onClick={() => handleDelete()}
            />
          </FileInfoDiv>
          {loading ? (
            <LoadingMessage>
              {loadingMessage}
              {loadingMessage === 'Carregando' && <img src={LoadingGif}></img>}
            </LoadingMessage>
          ) : null}
        </>
      )}
      <ButtonsDiv>
        <CancelButton onClick={() => setModalSection('addStockMenu')}>
          Cancelar
        </CancelButton>
        {tableFile === undefined ? (
          <DisabledNextButtonDiv onClick={() => handleSubmit()}>
            <DisabledNextButtonImage
              src={disabledArrowRight}
              alt='Right arrow icon'
            />
            <DisabledNextButtonText>Próximo</DisabledNextButtonText>
          </DisabledNextButtonDiv>
        ) : (
          <NextButtonDiv onClick={() => handleSubmit()}>
            <NextButtonImage src={arrowRight} alt='Right arrow icon' />
            <NextButtonText>Próximo</NextButtonText>
          </NextButtonDiv>
        )}
      </ButtonsDiv>
      {/* <StyledFileInput>
        Arraste para cá ou faça o upload
        <UploadButton htmlFor='table'>Selecione o arquivo</UploadButton>
        <FileInput
          type='file'
          id='table'
          name='table'
          onChange={handleUpload}
        />
      </StyledFileInput>
      {tableFile !== undefined ? (
        <>
          <ProgressDiv>
            <Icon src={FileImg} alt='Imagem de arquivo' />
            <FileName>
              {tableFile && tableFile[0]
                ? tableFile[0].name
                : 'Nenhum arquivo selecionado'}
            </FileName>

            <Percentage>{loadingPercentage}%</Percentage>
            <ProgressBar completion={loadingPercentage} />
            <ActionIcon
              src={CancelImg}
              alt='Ação'
              onClick={() => handleDelete()}
            />
          </ProgressDiv>

          {loading ? (
            <LoadingMessage>
              {loadingMessage}
              {loadingMessage === 'Carregando' && <img src={LoadingGif}></img>}
            </LoadingMessage>
          ) : (
            <NextButton onClick={() => handleSubmit()}>
              Próxima etapa
            </NextButton>
          )}
        </>
      ) : (
        <DisabledNextButton disabled>Próxima etapa</DisabledNextButton>
      )} */}
    </Container>
  )
}

export default UploadStep

